import axios from "axios";

import { apiDomain } from "../../store/constants";

const Dashboard = {
  getData(payload) {
    return axios({
      url:
        apiDomain +
        `api/dashboard/kpi?year=` +
        payload.year +
        `&region_id=` +
        payload.region_id,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
};

export default Dashboard;
